var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "notification" }, [
        _c("div", { staticClass: "icon-cont" }, [
          _c("i", { staticClass: "fas fa-plus-square" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "body-cont" }, [
          _c("span", [
            _vm._v("No sessions have been added yet. "),
            _c("br"),
            _vm._v(" "),
            _c("a", { attrs: { href: "#" } }, [_vm._v("Click Here")]),
            _vm._v(" to get started.")
          ]),
          _vm._v(" "),
          _c("i", { staticClass: "fas fa-eye" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "notification" }, [
        _c("div", { staticClass: "icon-cont" }, [
          _c("i", { staticClass: "fas fa-plus-square" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "body-cont" }, [
          _c("span", [
            _vm._v("No sessions have been added yet. "),
            _c("br"),
            _vm._v(" "),
            _c("a", { attrs: { href: "#" } }, [_vm._v("Click Here")]),
            _vm._v(" to get started.")
          ]),
          _vm._v(" "),
          _c("i", { staticClass: "fas fa-eye" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "notification" }, [
        _c("div", { staticClass: "icon-cont" }, [
          _c("i", { staticClass: "fas fa-plus-square" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "body-cont" }, [
          _c("span", [
            _vm._v("No sessions have been added yet. "),
            _c("br"),
            _vm._v(" "),
            _c("a", { attrs: { href: "#" } }, [_vm._v("Click Here")]),
            _vm._v(" to get started.")
          ]),
          _vm._v(" "),
          _c("i", { staticClass: "fas fa-eye" })
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ab78508e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab78508e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notificationList.vue
// module id = zznA
// module chunks = 1